import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Container, Row, Col } from 'reactstrap'
import { Auth } from 'aws-amplify'
import { Loader } from 'admin-console-common'
import { ModalInfo, ModalCode } from '../modules'
import { getDealers, getLabelMarket } from '../Helpers'
import Select from 'react-select'
import LoaderImg from '../assets/img/loader.gif'
import { useUserContext } from '../hooks/useUser'

const Profile = () => {
  const navigate = useNavigate()
  const [userInfos, setUserInfos] = useState({})
  const [email, setEmail] = useState('')
  const [dealer, setDealer] = useState([])
  const [dealers, setDealers] = useState([])
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loader, setLoader] = useState(true)
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [modalCodeIsOpen, setModalCodeIsOpen] = useState(false)
  const [error, setError] = useState('')
  const [code, setCode] = useState('')
  const [showPassword, setShowPassword] = useState('password')
  const [infosModal, setInfosModal] = useState('')
  const { user } = useUserContext()

  useEffect(() => {
    const fetchData = async () => {
      if (user) {
        const infos = await Auth.currentUserInfo()
        if (infos?.attributes['custom:entity'] === 'DEALER') {
          const { dealers } = await getDealers(
            infos.attributes['custom:market']
          )
          const dealer = dealers.filter(dealer =>
            infos.attributes['custom:entityId'].includes(dealer.value)
          )
          setDealers(dealers)
          setDealer(dealer)
        }
        setUserInfos(infos)
        setEmail(infos.attributes.email)
        setLoader(false)
      } else {
        navigate('/login')
      }
    }
    fetchData()
  }, [navigate, user])

  const changePwd = async () => {
    setLoader(true)
    if (oldPassword.length < 6 || newPassword < 6) {
      setError('Your password must have more than 6 characters.')
      setLoader(false)
      return
    }
    let userAws = Auth.currentAuthenticatedUser()
    if (newPassword === confirmPassword) {
      Auth.changePassword(userAws, oldPassword, newPassword)
        .then(() => {
          setOldPassword('')
          setNewPassword('')
          setConfirmPassword('')
          setInfosModal('Your password has been updated.')
          setModalIsOpen(true)
          setLoader(false)
        })
        .catch(error => {
          setError(error.message)
          setLoader(false)
        })
    } else {
      setError('Your new Password does not match your confirm Password.')
      setLoader(false)
    }
  }

  const changePasswordIsDisabled = () => {
    let isDisabled = true
    if (oldPassword && newPassword && confirmPassword) isDisabled = false
    return isDisabled
  }

  const handleCheckboxShow = () => {
    if (showPassword === 'text') setShowPassword('password')
    else setShowPassword('text')
  }

  const dealerToString = () => {
    let dealerString = ''
    for (let i = 0; i < dealer.length; i++)
      dealerString += dealer[i + 1] ? `${dealer[i].value};` : dealer[i].value

    return dealerString
  }

  const updateProfile = async () => {
    setLoader(true)

    let attributesUpdated = {
      'custom:entityId': dealerToString(),
    }

    if (email !== userInfos?.attributes?.email) attributesUpdated.email = email

    const userAws = await Auth.currentAuthenticatedUser()
    await Auth.updateUserAttributes(userAws, attributesUpdated)
    if (attributesUpdated?.email) {
      await Auth.verifyCurrentUserAttribute('email')
      setModalCodeIsOpen(true)
    }
    setLoader(false)
  }

  const updateProfileIsDisabled = () => {
    let isDisabled = true
    if (email && email !== userInfos?.attributes?.email) isDisabled = false
    else if (
      userInfos?.attributes['custom:entityId'] &&
      dealer.length > 0 &&
      dealerToString() !== userInfos?.attributes['custom:entityId']
    )
      isDisabled = false
    return isDisabled
  }

  const confirmCode = () => {
    if (code !== '') {
      Auth.verifyCurrentUserAttributeSubmit('email', code)
        .then(() => {
          setModalCodeIsOpen(false)
          setModalIsOpen(true)
          setInfosModal('Your profile has been updated.')
        })
        .catch(e => {
          console.log('failed with error', e)
        })
    }
  }

  return (
    <Container fluid>
      {loader ? (
        <Loader loaderImg={LoaderImg} />
      ) : (
        <div className="profile panel panel--light mt-5">
          <Row className="filters">
            <Col xs="6" lg="6">
              <h2>PROFILE</h2>
            </Col>
          </Row>
          <Row className="profile_infos">
            <Col xs="6">
              <label>Username : </label>
              <input value={userInfos.username} disabled />
              <label>Email : </label>
              <input value={email} onChange={e => setEmail(e.target.value)} />
              <label>Entity : </label>
              <input value={userInfos.attributes['custom:entity']} disabled />
            </Col>
            <Col xs="6">
              <label>Dashboard : </label>
              <input
                value={
                  userInfos.attributes['custom:entity'] === 'ADMIN'
                    ? 'All'
                    : userInfos.attributes['custom:dashboard'] !== ''
                    ? userInfos.attributes['custom:dashboard']
                    : '-'
                }
                disabled
              />
              {(userInfos.attributes['custom:entity'] === 'DEALER' ||
                userInfos.attributes['custom:entity'] === 'RBU') && (
                <>
                  <label>Market : </label>
                  <input
                    value={
                      userInfos.attributes['custom:entity'] === 'ADMIN'
                        ? 'All'
                        : userInfos.attributes['custom:market'] !== ''
                        ? getLabelMarket(userInfos.attributes['custom:market'])
                        : '-'
                    }
                    disabled
                  />
                </>
              )}
              {userInfos.attributes['custom:entity'] === 'DEALER' && (
                <>
                  <label>Dealer(s) : </label>
                  <Select
                    value={dealer}
                    onChange={dealer => setDealer(dealer)}
                    options={dealers}
                    isMulti={true}
                    isSearchable={true}
                    className="select-custom"
                    classNamePrefix="select-custom"
                    isDisabled={
                      userInfos.attributes['custom:entity'] !== 'DEALER'
                    }
                  />
                </>
              )}
            </Col>
            <Col xs="12">
              <button
                className="btn btn-nissan-red"
                disabled={updateProfileIsDisabled()}
                onClick={updateProfile}
              >
                Update profile
              </button>
            </Col>
          </Row>
          <hr />
          <Row className="profile_infos profile_password_infos">
            <Col xs="4">
              <label>Previous Password : </label>
              <input
                type={showPassword}
                value={oldPassword}
                onChange={e => setOldPassword(e.target.value)}
              />
            </Col>
            <Col xs="4">
              <label>New Password : </label>
              <input
                type={showPassword}
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
              />
            </Col>
            <Col xs="4">
              <label>Confirm New Password : </label>
              <input
                type={showPassword}
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
              />
            </Col>
            <Col xs="12">
              <div className="showpassword">
                <input
                  type="checkbox"
                  id="oldpassword"
                  onChange={handleCheckboxShow}
                />
                <label htmlFor="oldpassword">Show passwords</label>
              </div>
              <p className="profile_error">{error}</p>
              <button
                className="btn btn-nissan-red"
                disabled={changePasswordIsDisabled()}
                onClick={changePwd}
              >
                Change Password
              </button>
            </Col>
          </Row>
          <ModalInfo
            isOpen={modalIsOpen}
            close={() => setModalIsOpen(false)}
            info={infosModal}
            title="Success"
          />
          <ModalCode
            isOpen={modalCodeIsOpen}
            close={() => setModalCodeIsOpen(false)}
            code={code}
            change={e => setCode(e.target.value)}
            confirm={confirmCode}
          />
        </div>
      )}
    </Container>
  )
}

export default Profile
